import React from 'react';
import { Message } from './types';
import { formatCost } from '@/utils/chatCosts';
import { Coins } from 'lucide-react';

interface ConversationSummaryProps {
  messages: Message[];
}

const ConversationSummary: React.FC<ConversationSummaryProps> = ({ messages }) => {
  const totals = messages.reduce((acc, msg) => {
    if (msg.metadata) {
      acc.inputTokens += msg.metadata.input_tokens || 0;
      acc.outputTokens += msg.metadata.output_tokens || 0;
      acc.reasoningTokens += msg.metadata.reasoning_tokens || 0;
      acc.totalCost += msg.metadata.total_cost || 0;
    }
    return acc;
  }, { inputTokens: 0, outputTokens: 0, reasoningTokens: 0, totalCost: 0 });

  // Only show if we have any token data
  if (totals.inputTokens === 0 && totals.outputTokens === 0 && totals.totalCost === 0) {
    return null;
  }

  return (
    <div className="px-4 py-2 bg-muted/50 border-b">
      <div className="flex items-center justify-between text-xs">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Coins size={14} />
          <span>Conversation Totals</span>
        </div>
        <div className="flex items-center gap-4 font-mono">
          {totals.inputTokens > 0 && (
            <span>In: {totals.inputTokens.toLocaleString()}</span>
          )}
          {totals.outputTokens > 0 && (
            <span>Out: {totals.outputTokens.toLocaleString()}</span>
          )}
          {totals.reasoningTokens > 0 && (
            <span>Reasoning: {totals.reasoningTokens.toLocaleString()}</span>
          )}
          {totals.totalCost > 0 && (
            <span className="font-semibold text-foreground">
              {formatCost(totals.totalCost, false)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConversationSummary;
